import React from 'react';
import Rating from '@mui/material/Rating';

function RatingBox({ value }) {
  return (
    <div>
      <Rating
        style={{ 
          fontSize: '12px',color: 'white', marginTop: '3px', marginLeft: '5px', 
        }}
        precision={0.5}
        value={value}
        readOnly
      />
    </div>
  );
}

export default RatingBox;
